import { select } from "./auto-focus";

export default () => ({
  restrict: "A",
  scope: false,
  link(scope, element, attrs) {
    return "skipping this for now; jumping text issue";
    element.on("touchstart", function () {
      element.focus();
    });
    element.on("focus", function () {
      $timeout(function () {
        return select(element);
      }, 250);
    });
    if (attrs.focusNow)
      $timeout(function () {
        //TODO: consider global focus target.
        element.trigger("touchstart");
        element.focus();
      }, 250);
  },
});
